module.exports = __webpack_public_path__ + "img/1.ab2b038a.png";